export default class ApiError {
  constructor(message, data, code) {
    this.name = 'ApiError';
    this.message = message;
    this.data = data;
    this.code = code;
  }

  is(code) {
    return this.code === code;
  }
}
